import React, { Fragment } from "react"
import PropTypes from "prop-types"

export default function Iva(props) {
  const { price, text } = props
  return (
    <Fragment>
      <span className="Certification-iva">{price}</span>
      <span className="Certification-discount">{text}</span>
    </Fragment>
  )
}

Iva.propTypes = {
  price: PropTypes.string,
  text: PropTypes.string,
}

Iva.defaultProps = {
  price: "",
  text: "",
}
